// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2XPIU","inner":"Footer_inner__23l64","nextIcon":"Footer_nextIcon__2U5WG","innerLeft":"Footer_innerLeft__1v3EI"};